(function() {
'use strict';

angular
    .module('TR')
    .controller('Country', Country);

function Country(pagingService,
        urlUtils,
        $scope,
        $rootScope,
        pageStrand,
        destinationService,
        reviewService,
        windowUtil,
        imageService,
        countryService,
        broker,
        resourceService,
        bd4travel,
        $location,
        $q,
        currentDestination) {
    const cm = this;
    const inResource = resourceService.get('InDestination');

    cm.lightboxOpen = false;
    cm.mapReady = false;
    cm.loading = true;
    cm.loadingDestinations = true;
    cm.loadingCoords = true;
    cm.loadingReviews = true;
    cm.loadingInfo = true;
    cm.loadingChildren = true;
    cm.destinationThumb = destinationThumb;
    cm.openImageGallery = openImageGallery;
    cm.showReviews = showReviews;
    cm.popupMap = popupMap;
    cm.showAllDestinations = $location.search().allDest;
    const parsed = urlUtils.parse($location.url());
    parsed.qs.allDest = true;
    cm.allDestinationsUrl = urlUtils.stripLeadingSlash(urlUtils.format(parsed));
    cm.toggleDestinations = toggleDestinations;
    cm.pageReviews = page => {
        _getReviews(cm.selectedHotel, page);
    };
    function toggleDestinations(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!cm.showAllDestinations) {
            destinationService.getAllChildren(cm.destination).then(children => cm.all = buildPagePaths(children));
            cm.showAllDestinations = !cm.showAllDestinations;
        }
    }


    broker.subscribe('CountryCtrl', 'selectHotel', function(ev) {
        selectHotel(ev.data.hotel, ev.data.event);
    });

    broker.subscribe('CountryCtrl', 'lightboxOpened', function() {
        cm.lightboxOpen = true;
    });

    broker.subscribe('CountryCtrl', 'mapReady', function() {
        cm.mapReady = true;
    });

    $scope.$on('$destroy', function() {
        broker.unsubscribe('CountryCtrl');
    });

    function popupMap() {
        cm.showPopupMap = true;
    }

    function destinationThumb(dest) {
        return destinationService.destinationThumb(dest);
    }

    function buildPagePaths(children) {
        return destinationService.sortByTitle(children).map(function(child) {
            child.PagePath = urlUtils.appendExistingQueryString(urlUtils.stripLeadingSlash(child.PagePath));
            return child;
        });
    }

    currentDestination.getCurrentDestination().then(function(destination) {
        cm.destination = destination;

        const requests = [destinationService.getText(cm.destination), destinationService.getTopChildren(8, cm.destination)];
        if (cm.showAllDestinations) {
            requests.push(destinationService.getAllChildren(cm.destination));
        }

        $q.all(requests).then(result => {
            const text = result[0];
            const children = buildPagePaths(result[1]);
            const defaultStr = '{name}';

            if (cm.showAllDestinations) {
                cm.all = buildPagePaths(result[2]);
            }

            cm.dealsTitle = dest => String.supplant(text.List1Title || defaultStr, _getVarMap(dest));

            countryService.getTopDeals(2, cm.destination, children.slice(0, 3)).then(function(deals) {
                cm.greatDeals = deals;
                cm.loadingDeals = false;
            });

            cm.popular = children;
            cm.loadingDestinations = false;
            bd4travel.trackCategory(children);
        }).finally(() => {
            $rootScope.unlockScreen($scope);
        });
    });

    function selectHotel(hotel, e) {
        e.preventDefault();
        e.stopPropagation();
        if (TRPCONFIG.DeviceSettings.OpenHotelInNewWindow) {
            windowUtil.open(_getHotelUrl(false, hotel));
        } else {
            $location.path(_getHotelUrl(true, hotel));
        }
    }

    function getHotelUrl(hotel) {
        return _getHotelUrl(false, hotel);
    }

    function _getHotelUrl(leadingSlash, hotel) {
        let url = hotel.Url;
        const index = url.indexOf('/');
        if (!leadingSlash && index === 0) {
            url = url.substring(1);
        }
        if (leadingSlash && index !== 0) {
            url = `/${url}`;
        }
        return pageStrand.adjustUrl(url, cm.destination.PageStrand);
    }

    function openImageGallery(hotel, e) {
        e.preventDefault();
        e.stopPropagation();

        const w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
        const h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;

        cm.hotelImageIndex = 0;
        cm.hotelImages = [];

        for (let i = 0, l = hotel.NumberOfPhotos; i < l; i++) {
            cm.hotelImages.push({
                src: imageService.getImageUrl(hotel.Id, w, h, i, false)
            });
        }
        cm.showHotelImages = true;
    }

    function showReviews(hotel, ev) {
        ev.preventDefault();
        cm.reviews = [];
        cm.selectedHotel = hotel;
        cm.reviewPaging = pagingService.data(1, 10, hotel.CustomerRatingCount);
        _getReviews(hotel, cm.reviewPaging.page);
        cm.reviewsShowing = true;
        ev.stopPropagation();
    }

    function _getVarMap(dest) {
    // Variable mapping in string templates i.e. {name}
    // Also supports legacy numeric vars i.e. {0}
        return {
            0: dest.Title,
            1: inResource,
            name: dest.Title,
            in: inResource
        };
    }

    function _getReviews(hotel, page) {
        cm.loadingReviews = true;
        if (page === 1) {
            cm.loadingFirstReviews = true;
        }
        return reviewService.getReviews(hotel, page - 1).then(function(result) {
            cm.reviews = result.reviews;
            cm.loadingReviews = false;
            cm.loadingFirstReviews = false;
            cm.reviewPaging = pagingService.data(page, 10, hotel.CustomerRatingCount);
        });
    }

    cm.selectHotel = selectHotel;
    cm.getHotelUrl = getHotelUrl;

    cm.bookButton = function() {
        return resourceService.get('VIEWDETAILS');
    };
}
})();
